"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendMessageRequestAndImmediatelyExecute_NonHost = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var diveMovementIndicators_sidecar_1 = require("@dive/indicators/diveMovementIndicators-sidecar");
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.CrewMove;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crewId);
    // messageWriter.write16(m, d.si)
    // messageWriter.write16(m, d.sj)
    var len = d.path.length;
    messageWriter_sidecar_1.messageWriter.write16(m, len);
    for (var i = 0; i < len; i++) {
        var p = d.path[i];
        messageWriter_sidecar_1.messageWriter.write16(m, p[0]);
        messageWriter_sidecar_1.messageWriter.write16(m, p[1]);
    }
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        crewId: messageWriter_sidecar_1.messageWriter.read32(m),
        path: [],
    };
    var len = messageWriter_sidecar_1.messageWriter.read16(m);
    for (var i = 0; i < len; i++) {
        d.path.push([messageWriter_sidecar_1.messageWriter.read16(m), messageWriter_sidecar_1.messageWriter.read16(m)]);
    }
    return d;
}
exports.read = read;
function test() {
    var ex = {
        crewId: 100,
        path: [
            [1, 2],
            [3, 4],
        ],
    };
    messageWriter_sidecar_1.messageWriter.test('crew-move', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    var cr = diveCrew_sidecar_1.diveCrew.findById(msg.crewId);
    if (!cr) {
        websockets_sidecar_1.websockets.reportBadCommand(m, msg, 'crew is null');
        return;
    }
    // TODO: fix this?
    // voyageCrew_movable.networkRecievePathTo(cr, msg)
    if (msg.path.length > 0) {
        var mi = diveMovementIndicators_sidecar_1.diveMovementIndicators.create(voyageColors_sidecar_1.voyageColors.red);
        var lastPath = msg.path[msg.path.length - 1];
        diveMovementIndicators_sidecar_1.diveMovementIndicators.moveToIJ(mi, { i: lastPath[0], j: lastPath[1] });
    }
}
exports.process = process;
function SendMessageRequestAndImmediatelyExecute_NonHost(msg) {
    websockets_sidecar_1.websockets._sendMessageAndImmediatelyExecute_nonHost(write, msg);
}
exports.SendMessageRequestAndImmediatelyExecute_NonHost = SendMessageRequestAndImmediatelyExecute_NonHost;
